module.exports = __webpack_public_path__ + "img/cloud-right.3059d653.png";